module.exports = __webpack_public_path__ + "img/connected-computers-cyberpunk-style.be701ba6.jpg";